<template>
  <div class="page flex-col">
    <StudentHeader :title="title" />

    <div class="main_content_area flex-col">
      <div class="course_container flex-col">
        <div class="title_wrapper flex-col">
          <span class="page_title">选择课堂</span>
        </div>
        <div class="course_items_wrapper flex-row">
          <img
            class="left_navigation_arrow"
            referrerpolicy="no-referrer"
            src="../../assets/student/courselist/FigmaDDSSlicePNG8d972a6deea715ba2de2d9bfbcf4df23.png"
            @click="scrollLeftHandler"
          />
          <div
            class="course_list_scroll_container flex-row"
            ref="scrollContainer"
            @mousedown="handleMouseDown"
            @touchstart="handleTouchStart"
          >
            <div
              class="course_card flex-col"
              v-for="item in lists"
              @click="onClickCourse(item, $event)"
            >
              <span class="course_name"
                >{{ item.lessonSerialNo }}：{{ item.lessonName }}</span
              >
              <div class="course_image_container flex-col justify-between">
                <img
                  class="course_image"
                  referrerpolicy="no-referrer"
                  :src="item.imgUrl"
                  draggable="false"
                  @dragstart="(e) => e.preventDefault()"
                />
                <div class="progress_info flex-row justify-between">
                  <span class="completion_status"
                    >完成度（{{ item.completedTaskCount }}/{{
                      item.taskCount
                    }}）</span
                  >
                  <span class="progress_percentage">{{ item.progress }}</span>
                </div>
              </div>
              <div class="progress_bar">
                <div
                  :style="{ width: item.progress }"
                  class="progress_fill"
                ></div>
              </div>
            </div>
          </div>
          <img
            class="right_navigation_arrow"
            referrerpolicy="no-referrer"
            src="../../assets/student/courselist/FigmaDDSSlicePNGcee48b5acd65800ed505d2e96c783bdb.png"
            @click="scrollRightHandler"
          />
        </div>

        <div class="pagination_container flex-row justify-center w-full">
          <img
            v-for="(i, index) in Math.ceil(lists.length / 3)"
            :key="i"
            class="pagination_dot"
            referrerpolicy="no-referrer"
            :src="
              Math.floor(idx / 3) === index
                ? require('../../assets/student/courselist/FigmaDDSSlicePNGea97e2b39a9ea96d54e69d9a6fd422a3.png')
                : require('../../assets/student/courselist/FigmaDDSSlicePNGc6cb705320ec20357e1e1c360df51c9e.png')
            "
            @click="handlePaginationClick(index)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue"
import { useRoute, useRouter } from "vue-router"

import alovaInstance from "@/utils/alova"
import StudentHeader from "@/components/StudentHeader.vue"

const router = useRouter()
const route = useRoute()
const title = ref("课程")
const idx = ref(0)

const lists = ref([])
const scrollContainer = ref(null)
const isDragging = ref(false)
const startX = ref(0)
const scrollLeft = ref(0)
const dragThreshold = ref(3) // 降低阈值减少延迟
const hasMoved = ref(false) // 记录是否移动过
const isClick = ref(true) // 优化点击判断
// 新增：获取课程列表数据的方法
const fetchCourseList = async () => {
  try {
    const response = await alovaInstance.Post(
      "/Lesson/GetLessonNavigatorListInfo",
      {
        courseId: route.query.id,
      }
    )
    if (response.code === 1000) {
      for (let i = 0; i < response.data.length; i++) {
        response.data[i].progress =
          response.data[i].taskCount === 0
            ? "0%"
            : Math.round(
                (response.data[i].completedTaskCount /
                  response.data[i].taskCount) *
                  100
              ) + "%"
      }
      lists.value = response.data
      // .concat(response.data)
    } else {
      alert("获取课程列表失败：" + response.message)
    }
  } catch (error) {
    console.error("获取课程数据失败:", error)
    alert("加载课程列表失败，请稍后重试")
  }
}

// 组件挂载后自动获取数据
onMounted(() => {
  fetchCourseList()
  title.value = localStorage.getItem("title")
})

const onClickCourse = (item, event) => {
  // 如果正在拖动或移动过，不触发点击事件
  if (isDragging.value || !isClick.value || hasMoved.value) {
    event.preventDefault()
    event.stopPropagation()
    return
  }

  router.push({
    name: "Course",
    query: {
      courseId: item.lessonId,
      courseName: item.lessonSerialNo + "：" + item.lessonName,
    },
  })
}

// 滚动相关方法
const scrollLeftHandler = () => {
  if (scrollContainer.value) {
    idx.value -= 1
    if (idx.value < 0) idx.value = 0
    const container = scrollContainer.value
    const scrollAmount = 320 + 18
    container.scrollBy({ left: -scrollAmount, behavior: "smooth" })
  }
}

const scrollRightHandler = () => {
  if (scrollContainer.value) {
    idx.value += 1
    if (idx.value > lists.value.length - 3) idx.value = lists.value.length - 3
    const container = scrollContainer.value
    const scrollAmount = 320 + 18
    container.scrollBy({ left: scrollAmount, behavior: "smooth" })
  }
}

// 全局鼠标事件处理方法
const handleGlobalMouseMove = (e) => {
  if (!isDragging.value || !scrollContainer.value) return

  e.preventDefault()
  const x = e.clientX
  const walk = x - startX.value

  // 检查是否超过阈值
  if (Math.abs(walk) > dragThreshold.value) {
    hasMoved.value = true
    isClick.value = false
  }

  // 直接应用滚动，无延迟
  scrollContainer.value.scrollLeft = scrollLeft.value - walk
}

const handleGlobalMouseUp = () => {
  if (!scrollContainer.value) return

  // 清理全局事件监听
  document.removeEventListener("mousemove", handleGlobalMouseMove)
  document.removeEventListener("mouseup", handleGlobalMouseUp)

  isDragging.value = false

  // 计算当前滚动位置对应的idx值
  if (scrollContainer.value) {
    const container = scrollContainer.value
    const cardWidth = 320 + 18 // 卡片宽度 + 右边距
    const cardsPerPage = 3
    const pageWidth = cardWidth * cardsPerPage
    
    // 计算当前页数索引
    const currentPage = Math.round(container.scrollLeft / pageWidth)
    const newIdx = currentPage * cardsPerPage
    
    // 限制范围并更新idx
    if (newIdx >= 0 && newIdx < lists.value.length) {
      idx.value = newIdx
    } else if (newIdx >= lists.value.length) {
      idx.value = Math.max(0, lists.value.length - 1)
    } else {
      idx.value = 0
    }
  }

  // 延迟重置状态，避免误触发
  setTimeout(() => {
    hasMoved.value = false
    isClick.value = true
    if (scrollContainer.value) {
      scrollContainer.value.style.cursor = "grab"
      scrollContainer.value.style.userSelect = ""
    }
  }, 0)
}

// 优化后的鼠标按下事件
const handleMouseDown = (e) => {
  if (!scrollContainer.value) return

  isDragging.value = true
  hasMoved.value = false
  isClick.value = true

  startX.value = e.clientX
  scrollLeft.value = scrollContainer.value.scrollLeft

  scrollContainer.value.style.cursor = "grabbing"
  scrollContainer.value.style.userSelect = "none"

  // 添加全局事件监听
  document.addEventListener("mousemove", handleGlobalMouseMove)
  document.addEventListener("mouseup", handleGlobalMouseUp)
}

// 全局触摸事件处理方法
const handleGlobalTouchMove = (e) => {
  if (!isDragging.value || !scrollContainer.value) return

  const x = e.touches[0].clientX
  const walk = x - startX.value

  if (Math.abs(walk) > dragThreshold.value) {
    hasMoved.value = true
    isClick.value = false
  }

  scrollContainer.value.scrollLeft = scrollLeft.value - walk
}

const handleGlobalTouchEnd = () => {
  if (!scrollContainer.value) return

  // 清理全局事件监听
  document.removeEventListener('touchmove', handleGlobalTouchMove)
  document.removeEventListener('touchend', handleGlobalTouchEnd)

  isDragging.value = false

  // 计算当前滚动位置对应的idx值（触摸设备）
  if (scrollContainer.value) {
    const container = scrollContainer.value
    const cardWidth = 320 + 18 // 卡片宽度 + 右边距
    const cardsPerPage = 3
    const pageWidth = cardWidth * cardsPerPage
    
    // 计算当前页数索引
    const currentPage = Math.round(container.scrollLeft / pageWidth)
    const newIdx = currentPage * cardsPerPage
    
    // 限制范围并更新idx
    if (newIdx >= 0 && newIdx < lists.value.length) {
      idx.value = newIdx
    } else if (newIdx >= lists.value.length) {
      idx.value = Math.max(0, lists.value.length - 1)
    } else {
      idx.value = 0
    }
  }

  setTimeout(() => {
    hasMoved.value = false
    isClick.value = true
  }, 0)
}

// 优化后的触摸事件
const handleTouchStart = (e) => {
  if (!scrollContainer.value) return

  isDragging.value = true
  hasMoved.value = false
  isClick.value = true

  startX.value = e.touches[0].clientX
  scrollLeft.value = scrollContainer.value.scrollLeft

  document.addEventListener("touchmove", handleGlobalTouchMove, {
    passive: false,
  })
  document.addEventListener("touchend", handleGlobalTouchEnd)
}

// 分页点点击事件
const handlePaginationClick = (index) => {
  if (!scrollContainer.value) return

  idx.value = index * 3
  const container = scrollContainer.value
  const cardWidth = 320 + 18 // 卡片宽度 + 右边距
  const cardsPerPage = 3
  const scrollPosition = index * (cardWidth * cardsPerPage)

  container.scrollTo({
    left: scrollPosition,
    behavior: "smooth",
  })
}

onUnmounted(() => {
  // 清理全局事件监听器
  document.removeEventListener("mousemove", handleGlobalMouseMove)
  document.removeEventListener("mouseup", handleGlobalMouseUp)
  document.removeEventListener("touchmove", handleGlobalTouchMove)
  document.removeEventListener("touchend", handleGlobalTouchEnd)
})
</script>

<style src="@/assets/common.css" />
<style scoped>
.page {
  background-color: rgba(234, 238, 242, 1);
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 48vw;
  overflow: hidden;
}

.main_content_area {
  position: relative;
  width: 100vw;
  height: calc(100vh - 2.87vw);
  min-height: calc(48vw - 2.87vw);
  margin-bottom: 0.06vw;
}

.course_container {
  box-shadow: 2px 2px 6px 3px rgba(12, 12, 13, 0.05);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 32px;
  width: 75vw;
  height: calc(100vh - 5.57vw);
  min-height: calc(48vw - 5.57vw);
  margin: 1.35vw 0 0 12.5vw;
}

.title_wrapper {
  background-color: rgba(128, 174, 243, 1);
  border-radius: 32px 32px 0px 0px;
  height: 2.87vw;
  width: 75vw;
}

.page_title {
  width: 6.67vw;
  height: 2.19vw;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 1.5vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.67vw;
  margin: 0.5vw 0 0 34.16vw;
}

.course_items_wrapper {
  width: 68.55vw;
  height: 36.31vw;
  margin-top: 0.65vw;
  cursor: pointer;
}

.left_navigation_arrow {
  width: 3.34vw;
  height: 3.34vw;
  margin-top: 16.31vw;
  cursor: pointer;
}

.course_list_scroll_container {
  width: 68.3vw;
  height: 36.31vw;
  margin-left: 0;
  overflow-x: auto;
  overflow-y: hidden;
  cursor: grab;
  scroll-behavior: auto; /* 改为auto减少滚动延迟 */
  -webkit-overflow-scrolling: touch; /* 支持iOS惯性滚动 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  touch-action: pan-x; /* 启用浏览器优化 */
  will-change: scroll-position; /* 启用硬件加速 */
}

.course_list_scroll_container:active {
  cursor: grabbing;
}

.course_list_scroll_container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.course_card {
  box-shadow: 2px 2px 6px 3px rgba(12, 12, 13, 0.05);
  background-color: rgba(240, 244, 247, 1);
  border-radius: 28px;
  width: 20.84vw;
  height: 36.31vw;
  margin-right: 1.25vw;
}

.course_name {
  width: 20.84vw;
  height: 1.67vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.25vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.25vw;
  margin-top: 1.46vw;
  overflow: hidden;
  text-overflow: ellipsis;
}

.course_image_container {
  width: 20.84vw;
  height: 27.19vw;
  margin-top: 1.1vw;
  cursor: pointer;
}

.course_image {
  width: 20.84vw;
  height: 24.85vw;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  pointer-events: none;
}

.progress_info {
  width: 17.71vw;
  height: 1.25vw;
  margin: 1.09vw 0 0 1.56vw;
}

.completion_status {
  width: 6.67vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Inter-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.05vw;
}

.progress_percentage {
  width: 2.66vw;
  height: 1.25vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Inter-Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 1.05vw;
}

.progress_bar {
  width: 18vw;
  height: 1.25vw;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  margin: 1.5vw 0 0 1.56vw;
}

.progress_fill {
  height: 100%;
  background: linear-gradient(#f3ab45 0%, #ffd75c 100%);
  transition: width 0.3s ease;
}

.right_navigation_arrow {
  width: 3.34vw;
  height: 3.34vw;
  margin: 16.31vw 0 0 0;
  cursor: pointer;
}

.pagination_container {
  width: 100%;
  height: 1.25vw;
  margin-top: 0.1vw;
}

.pagination_dot {
  width: 1.8vw;
  height: 1.8vw;
  margin: 0.4vw 0.5vw 0 0.5vw;
  cursor: pointer;
}
</style>
